module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_D.2bd80e9a.mp3";